__turbopack_context__.v({
  "--children-are-centered-horizontally": "section-module-scss-module__KusYia__--children-are-centered-horizontally",
  "--children-are-together": "section-module-scss-module__KusYia__--children-are-together",
  "--is-centered": "section-module-scss-module__KusYia__--is-centered",
  "--is-centered-horizontally": "section-module-scss-module__KusYia__--is-centered-horizontally",
  "--is-centered-vertically": "section-module-scss-module__KusYia__--is-centered-vertically",
  "--is-display-block": "section-module-scss-module__KusYia__--is-display-block",
  "--is-div": "section-module-scss-module__KusYia__--is-div",
  "--is-fixed-to-bottom": "section-module-scss-module__KusYia__--is-fixed-to-bottom",
  "--is-fixed-to-top": "section-module-scss-module__KusYia__--is-fixed-to-top",
  "--is-flex-column": "section-module-scss-module__KusYia__--is-flex-column",
  "--is-flex-row": "section-module-scss-module__KusYia__--is-flex-row",
  "--is-flex-wrap": "section-module-scss-module__KusYia__--is-flex-wrap",
  "--is-footer": "section-module-scss-module__KusYia__--is-footer",
  "--is-full-height": "section-module-scss-module__KusYia__--is-full-height",
  "--is-full-width": "section-module-scss-module__KusYia__--is-full-width",
  "--is-justified": "section-module-scss-module__KusYia__--is-justified",
  "--is-light-gray": "section-module-scss-module__KusYia__--is-light-gray",
  "--is-main": "section-module-scss-module__KusYia__--is-main",
  "--is-making-room-for-footer-ad": "section-module-scss-module__KusYia__--is-making-room-for-footer-ad",
  "--is-nav": "section-module-scss-module__KusYia__--is-nav",
  "--is-scrolling": "section-module-scss-module__KusYia__--is-scrolling",
  "section": "section-module-scss-module__KusYia__section",
});
